module.exports = __webpack_public_path__ + "bg.5d2babc9fd8cf9676bdd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bg.svg
// module chunks = styles